var _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrewCamLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 563,
    height: 512,
    viewBox: "0 0 563 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2856_2560)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M619.299 -51.2002H-56.3008V563.2H619.299V-51.2002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M619.299 -51.2002H-56.3008V563.2H619.299V-51.2002Z",
    fill: "#0BB089"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2856_2560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 66,
    y: 60,
    width: 362,
    height: 394
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0586 60.0747H427.88V453.291H66.0586V60.0747Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2856_2560)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2856_2560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -23,
    y: -20,
    width: 609,
    height: 554
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M281.501 -19.8882L585.65 256.709L281.501 533.306L-22.6543 256.709L281.501 -19.8882Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2856_2560)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2856_2560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -23,
    y: -20,
    width: 609,
    height: 554
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.501 -19.8882L585.65 256.709L281.501 533.306L-22.6543 256.709L281.501 -19.8882Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2856_2560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.344 384.656C330.271 442.261 219.208 439.493 149.777 376.357C76.9917 310.16 76.9917 203.034 149.777 136.837C219.208 73.6956 330.266 70.9329 403.344 128.533C409.056 133.034 417.607 132.789 422.949 127.93C428.837 122.576 428.503 113.802 422.216 108.832C404.365 94.7303 384.284 83.5196 362.345 75.4289C336.588 65.9303 309.376 61.1143 281.466 61.1143C253.557 61.1143 226.339 65.9303 200.588 75.4289C173.91 85.2689 149.982 99.7116 129.468 118.373C108.954 137.029 93.0724 158.784 82.2523 183.045C71.8074 206.469 66.5117 231.216 66.5117 256.597C66.5117 281.978 71.8074 306.725 82.2523 330.149C93.0666 354.41 108.954 376.165 129.468 394.821C149.982 413.477 173.91 427.925 200.588 437.765C226.339 447.258 253.557 452.08 281.466 452.08C309.376 452.08 336.588 447.264 362.345 437.765C384.284 429.674 404.365 418.464 422.216 404.357C428.503 399.392 428.837 390.618 422.949 385.264C417.607 380.405 409.056 380.16 403.344 384.656Z",
    fill: "white"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2856_2560",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 132,
    width: 270,
    height: 245
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.441 132.267H414.092V376.581H145.441V132.267Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2856_2560)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.717 376.491C353.875 376.491 413.992 321.819 413.992 254.379C413.992 186.939 353.875 132.267 279.717 132.267C205.559 132.267 145.441 186.939 145.441 254.379C145.441 321.819 205.559 376.491 279.717 376.491ZM267.085 195.765C258.945 195.765 251.508 199.947 247.866 206.565L245.045 211.701C243.832 213.909 241.351 215.301 238.641 215.301H229.586C217.722 215.301 208.104 224.048 208.104 234.843V293.456C208.104 304.245 217.722 312.992 229.586 312.992H329.847C341.711 312.992 351.329 304.245 351.329 293.456V234.843C351.329 224.048 341.711 215.301 329.847 215.301H320.798C318.083 215.301 315.602 213.909 314.388 211.701L311.567 206.565C307.926 199.947 300.489 195.765 292.349 195.765H267.085ZM279.717 241.355C267.853 241.355 258.235 250.101 258.235 260.891C258.235 271.68 267.853 280.427 279.717 280.427C291.581 280.427 301.199 271.68 301.199 260.891C301.199 250.101 291.581 241.355 279.717 241.355ZM243.908 260.891C243.908 242.907 259.942 228.331 279.717 228.331C299.492 228.331 315.526 242.907 315.526 260.891C315.526 278.875 299.492 293.456 279.717 293.456C259.942 293.456 243.908 278.875 243.908 260.891Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2856_2560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 563,
    height: 512,
    rx: 18.18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrewCamLogo);
export default __webpack_public_path__ + "static/media/CrewCam_Logo.c8fdc47abc7feba21d77bc7679a6655a.svg";
export { ForwardRef as ReactComponent };